import { css } from 'styled-components';
import { StyledCardGrid } from '../../../../../components/RelatedContent/DetailedRelatedContentWithVisibilityToggle/styles';
import spacing from '../../../../../helpers/spacing';

export default css`
  && ${StyledCardGrid} {
    margin-top: ${spacing(1)};
  }
`;
